import { api } from "../lib/axios"

import type { ApiData } from "./apiData"
import type { Space } from "../types/space"

interface GetSpaceRouteParam { 
    spaceId: string
}

type GetSpaceResponse = ApiData<Space>

async function getSpace({ spaceId }: GetSpaceRouteParam) {
    const response = await api.get<GetSpaceResponse>(`company-spaces/${spaceId}`)

    return response.data
}

export {
    getSpace,
    type GetSpaceRouteParam,
    type GetSpaceResponse,
}